import { useState } from "react";
import { ChevronRight } from "lucide-react";

function labelFor(key: string): string {
  return key.replaceAll("_", " ").replace(/\b\w/gu, (letter) => letter.toUpperCase());
}

export function JsonView({ value, depth = 0 }: { value: unknown; depth?: number }) {
  if (value === null || value === undefined || value === "") return <span className="empty-value">Not provided</span>;
  if (typeof value === "string") {
    if (/^https?:\/\//u.test(value)) return <a href={value} target="_blank" rel="noreferrer">{value}</a>;
    return <span className="prose-value">{value}</span>;
  }
  if (typeof value === "number" || typeof value === "boolean") return <span className="data-value">{String(value)}</span>;
  if (Array.isArray(value)) {
    if (value.length === 0) return <span className="empty-value">None</span>;
    return <div className="array-view">{value.map((item, index) => <div className="array-row" key={index}><span className="array-index">{String(index + 1).padStart(2, "0")}</span><JsonView value={item} depth={depth + 1} /></div>)}</div>;
  }
  if (typeof value === "object") {
    return <div className="object-view">{Object.entries(value).map(([key, item]) => <ObjectField key={key} name={key} value={item} depth={depth} />)}</div>;
  }
  return <span>{String(value)}</span>;
}

function ObjectField({ name, value, depth }: { name: string; value: unknown; depth: number }) {
  const complex = typeof value === "object" && value !== null;
  const [open, setOpen] = useState(false);
  if (!complex) return <div className="object-field"><dt>{labelFor(name)}</dt><dd><JsonView value={value} depth={depth + 1} /></dd></div>;
  return <div className="disclosure-field">
    <button type="button" className="disclosure-trigger" onClick={() => setOpen((current) => !current)} aria-expanded={open}>
      <ChevronRight size={15} className={open ? "is-open" : ""} aria-hidden="true" />
      <span>{labelFor(name)}</span>
      <span className="disclosure-count">{Array.isArray(value) ? value.length : Object.keys(value).length}</span>
    </button>
    {open && <div className="disclosure-content"><JsonView value={value} depth={depth + 1} /></div>}
  </div>;
}
